import graphql__dcee8cb674590042d2bb from "./__generated__/MapUsersList_usersMap.graphql.js";import { useCallback, useContext } from "react";
import { graphql, usePaginationFragment } from "react-relay";

import MapUsersListUser from "./MapUsersListUser";
import InfinitelyScrollableContainer from "../../Utils/InfinitelyScrollableContainer";
import { USERS_MAP_USERS_COUNT } from "../../Routes/UsersMapRoute";
import { MapPanelSizingContext } from "../MapPanel/withMapPanelSizing";
import { BoxSpinner } from "../../Utils/Spinner";
import { useMapUsersFiltering } from "./useMapUsersFiltering";
import { useMissingSelectedUserLoader } from "./useMissingSelectedUserLoader";

const MapUsersList = props => {
  const {
    data: usersMap,
    refetch,
    loadNext,
    hasNext,
    isLoadingNext
  } = usePaginationFragment(MapUsersList_usersMap, props.usersMap);

  // Ensure that the users list is refetched whenever a filter is updated
  useMapUsersFiltering(refetch);
  // Ensure that if an item is selected from a map marker click, we load it to display its
  // details in the users list here
  useMissingSelectedUserLoader(usersMap);

  const usersMapUsers = usersMap.usersMapUsers?.edges?.map(({ node }) => node) || [];

  const loadMore = useCallback(() => {
    if (!hasNext || isLoadingNext) return;

    loadNext(USERS_MAP_USERS_COUNT);
  }, [hasNext, isLoadingNext, loadNext]);

  // We use the map sidebar inner panel as our scroll container so that when we reach the
  // bottom of the container the next users batch is loaded
  const { innerPanel } = useContext(MapPanelSizingContext);

  if (!innerPanel || !usersMapUsers.length) return null;

  return (
    <InfinitelyScrollableContainer
      className="map-users-list boxes-list"
      onBottomReached={loadMore}
      scrollableContainer={innerPanel}
      offset={300}
    >
      {usersMapUsers.map(usersMapUser => (
        <MapUsersListUser key={usersMapUser.id} usersMapUser={usersMapUser} />
      ))}

      {isLoadingNext && <BoxSpinner />}
    </InfinitelyScrollableContainer>
  );
};

const MapUsersList_usersMap = graphql__dcee8cb674590042d2bb;

export default MapUsersList;
